import { BasicCommandVO } from "@goodgamestudios/core";
import { SFConstants } from "../../constants/SFConstants";

export class C2STutorialStepVO extends BasicCommandVO {
    public SID: number = 0;

    public getCmdId(): string {
        return "tst";
    }

    constructor(stepId: number) {
        CONSTRUCTOR_HACK;
        super();
        this.SID = stepId;
    }
}
